module.exports = __webpack_public_path__ + "media/images/support/geolocation/geolocation-edge-permission-1-8f59a0dd4a0774980e0eb66341f450c7.png";